if (!customElements.get('cart-variant-remover')) {
  customElements.define(
    'cart-variant-remover',
    class CartVariantRemover extends HTMLElement {
      constructor() {
        super();
        this.timer = null;
        this.onQueueEnd = this.onQueueEnd.bind(this);
      }

      connectedCallback() {
        document.addEventListener('liquid-ajax-cart:queue-end', this.onQueueEnd);
        this.scheduleCheck(0);
      }

      disconnectedCallback() {
        document.removeEventListener('liquid-ajax-cart:queue-end', this.onQueueEnd);

        if (this.timer) window.clearTimeout(this.timer);
        this.timer = null;
      }

      onQueueEnd() {
        this.scheduleCheck(50);
      }

      scheduleCheck(delayMs) {
        if (this.timer) window.clearTimeout(this.timer);
        this.timer = window.setTimeout(() => this.checkAndRemove(), delayMs);
      }

      checkAndRemove() {
        const keysRaw = this.getAttribute('data-remove-line-item-keys') || '';
        const keys = keysRaw.split(',').map((k) => k.trim()).filter(Boolean);

        if (keys.length === 0) return;

        const liquidAjaxCart = window.liquidAjaxCart;
        if (!liquidAjaxCart || typeof liquidAjaxCart.update !== 'function') return;

        const updates = {};
        keys.forEach((key) => {
          updates[key] = 0;
        });

        liquidAjaxCart.update({ updates });
      }
    }
  );
}


